const config = {
  apiUri: 'https://api.demo.kuhnert-messtechnik.de',
  errorPath: '/error',
  debounceTime: 5000,
};

export const environment = {
  production: false,
  // uVI-Portal-Login: eigener Realm "uvi" mit Public Client "uvi-portal"
  // (PKCE, Audience uvi-api) — Einrichtung siehe kmt-backend/deploy/KEYCLOAK-UVI.md.
  // Gleicher Keycloak wie Prod/lokal (kein eigener Staging-Realm); nur das Backend
  // ist Staging (api.demo, eigene DB, siehe kmt-backend/deploy/RUNBOOK.md).
  keycloak: {
    url: 'https://auth.kuhnert-messtechnik.de',
    realm: 'uvi',
    clientId: 'uvi-portal',
  },
  httpInterceptor: {
    allowedList: [`${config.apiUri}/*`],
  },
  apiUri: config.apiUri,
  debounceTime: config.debounceTime,
};
